import { Block } from "@material-ui/icons";
import CommonButton from "app/common/Component/Button/CommonButton";
import PopupForm from "app/common/Component/Popup/PopupForm";
import { observer } from "mobx-react";
import React, { memo, useEffect } from "react";
import { useStore } from "app/stores";
import TableComponent from "app/common/Component/Table/TableComponent";
import { Grid } from "@material-ui/core";
import { getDateTime } from "app/common/LocalFunction";

const RegisterServiceHistoryPopup = ({
  open,
  handleClose,
  // resetPopupStore,
}) => {

  const {
    dataRegisterServiceHistory,
    searchRegisterServiceHistory,
    resetPopupStore,
    handleChangeFormSearchRegisterServiceHistory,
    fetchPagingRegisterServiceHistory,
    selectRegisterServiceId
  } = useStore().patientManagementStore.registerServiceStore;

  useEffect(() => {
    if (selectRegisterServiceId) {
      handleChangeFormSearchRegisterServiceHistory({
        ...searchRegisterServiceHistory,
        patientServiceRegisterId: selectRegisterServiceId,
      });
      // fetchPagingRegisterServiceHistory();
    }
  }, [selectRegisterServiceId]);

  const renderStaffRevenue = (staffRevenueValue) => {
    if (typeof staffRevenueValue !== 'string') return null;

    const lines = staffRevenueValue.trim().split('\n');

    const items = [];
    for (let i = 0; i < lines.length; i += 2) {
      const infoLine = lines[i];
      const amountLine = lines[i + 1] || '';
      items.push({ infoLine, amountLine });
    }

    return (
      <div>
        {items.map((item, index) => (
          <div key={index}>
            <div><strong>{item.infoLine}</strong></div>
            <div>{item.amountLine}</div>
          </div>
        ))}
      </div>
    );
  };


  return (
    <PopupForm
      open={open}
      size="xl"
      handleClose={handleClose}
      title={`Lịch sử chỉnh sửa dịch vụ`}
      action={({ isSubmitting, setFieldValue, submitForm }) => {
        return (
          <div className="flex-center gap-1">
            <CommonButton className="btn-gray" onClick={handleClose}>
              <Block className="mr-2" /> Đóng
            </CommonButton>
          </div>
        );
      }}
    >
      {({ setFieldValue, values }) => {
        return (
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TableComponent
                titleNodata={"noData"}
                //showOrdinalNumbers
                data={dataRegisterServiceHistory?.content || []}
                name="ListRegisterServiceHistory"
                columns={[
                  {
                    field: "patientRegisterServiceName",
                    title: "Tên dịch vụ đăng ký",
                    align: "right",
                    render: (val) => (val?.patientServiceRegisterName),
                  },
                  {
                    field: "name",
                    title: "Tên dịch vụ",
                    align: "right",
                    render: (val) => (val?.healthCareServiceCode + " - " + val?.healthCareServiceName),
                  },
                  {
                    field: "price",
                    title: "Giá",
                    align: "right",
                    render: (val) => (val?.price),
                  },
                  {
                    field: "percentDiscount",
                    title: "% giảm giá",
                    align: "right",
                    render: (val) => (val?.percentDiscount),
                  },
                  {
                    title: 'Phân bổ doanh thu (nhân viên)',
                    field: 'staffRevenueValue',
                    align: "left",
                    render: (val) => renderStaffRevenue(val?.staffRevenueValue),
                  },
                  {
                    field: "patientName",
                    title: "Khách hàng",
                    align: "right",
                    render: (val) => (val?.patientCode + " - " + val?.patientName),
                  },
                  {
                    field: "personChange",
                    title: "Người chỉnh sửa",
                    align: "right",
                    render: (val) => (val?.personChange),
                  },
                  {
                    field: "createdBy",
                    title: "Tên tài khoản",
                    align: "right",
                    render: (val) => (val?.createdBy),
                  },
                  {
                    field: "createDate",
                    title: "Thời gian chỉnh sửa",
                    align: "right",
                    render: (val) => getDateTime(val?.createDate),
                  }
                ]}
                dataPagination={{
                  pageIndex: searchRegisterServiceHistory?.pageIndex,
                  pageSize: searchRegisterServiceHistory?.pageSize,
                  totalElements: dataRegisterServiceHistory?.totalElements,
                  totalPages: dataRegisterServiceHistory?.totalPages,
                  setPageIndex: (pageIndex) =>
                    handleChangeFormSearchRegisterServiceHistory({ pageIndex }),
                  setPageSize: (pageSize) =>
                    handleChangeFormSearchRegisterServiceHistory({ pageSize }),
                }}
              />
            </Grid>
          </Grid>
        );
      }}
    </PopupForm>
  );
}


export default memo(observer(RegisterServiceHistoryPopup));
